import { render, staticRenderFns } from "./modal-buttons.component.vue?vue&type=template&id=2d4e604d"
import script from "./modal-buttons.component.vue?vue&type=script&lang=js"
export * from "./modal-buttons.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports